import { render, staticRenderFns } from "./regulations.vue?vue&type=template&id=50803a38&scoped=true&"
import script from "./regulations.vue?vue&type=script&lang=js&"
export * from "./regulations.vue?vue&type=script&lang=js&"
import style0 from "./regulations.vue?vue&type=style&index=0&id=50803a38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50803a38",
  null
  
)

export default component.exports